<template>
  <div class="main-content contact-page">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="contact-cnt">
            <div class="contact-list">
              <div v-for="contact in contacts" :key="contact.id" class="contact-item">
                <div v-if="contact.info" class="contact-item__info">
                  <p class="contact-item__region">{{ contact.info.region }}</p>
                  <p class="contact-item__address">
                    {{ contact.info.addressLine1 }}
                    <template v-show="contact.info.addressLine2"> <br />{{ contact.info.addressLine2 }} </template>
                  </p>
                  <p class="contact-item__country">{{ contact.info.country }}</p>
                  <p class="contact-item__phone">
                    <a :href="`tel:${contact.info.phone}`">{{ contact.info.phone }}</a>
                  </p>
                </div>
                <div class="contact-item__link">
                  <a
                    :href="contact.link.url"
                    target="_blank"
                    rel="noopener noreferrer"
                    @click="handleLinkClick(contact.link)"
                  >
                    <span class="contact-item__link__icon">
                      <TheInstagramIcon />
                    </span>
                    <span class="contact-item__link__txt-box">
                      <span class="contact-item__link__txt">{{ contact.link.label }}</span>
                      <span class="contact-item__link__under-txt">{{ contact.link.subtext }}</span>
                    </span>
                    <span class="contact-item__link__arrow">
                      <TheArrowHorizIcon flip="flip" />
                    </span>
                  </a>
                </div>
              </div>
            </div>

            <div class="contact-body">
              <div class="contact-title">Send an email</div>
              <AddSpecRequestForm :init-text="formInitText" @added="handleFormSubmitted" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheInstagramIcon from '@/components/icons/TheInstagramIcon.vue';
import TheArrowHorizIcon from '@/components/icons/TheArrowHorizIcon.vue';
import AddSpecRequestForm from '@/components/partials/profile/AddSpecRequestForm.vue';
import { sendGaEvent } from '@/helpers/ga/gaSend';
import ContactClickedGaEvent from '@/helpers/ga/events/ContactClickedGaEvent';
import ContactFormSubmittedGaEvent from '@/helpers/ga/events/ContactFormSubmittedGaEvent';
import ExternalLinkClickedGaEvent from '@/helpers/ga/events/ExternalLinkClickedGaEvent';

export default {
  components: { TheInstagramIcon, TheArrowHorizIcon, AddSpecRequestForm },
  metaInfo: {
    title: 'Contact us',
  },
  data() {
    return {
      contacts: [
        {
          id: 'contact_europe',
          info: {
            region: 'Europe',
            addressLine1: '61 Tottenham Court Road',
            addressLine2: 'London, W1T 2EP',
            country: 'United Kingdom',
            phone: '+44 [0] 203 384 0055',
          },
          link: {
            platform: 'instagram',
            url: 'https://www.instagram.com/thecultivisteurope',
            label: 'Follow on Instagram',
          },
        },
        {
          id: 'contact_america',
          info: {
            region: 'Americas',
            addressLine1: '55 Fifth Avenue, Suite 1305',
            addressLine2: 'New York, NY 10003',
            country: 'United States',
            phone: '+1 212 257 0202',
          },
          link: {
            platform: 'instagram',
            url: 'https://www.instagram.com/thecultivistamericas',
            label: 'Follow on Instagram',
          },
        },
        {
          id: 'contact_global',
          info: null,
          link: {
            platform: 'instagram',
            url: 'https://www.instagram.com/thecultivist',
            label: 'Follow on Instagram',
            subtext: 'Global account',
          },
        },
      ],
    };
  },

  computed: {
    formInitText() {
      return this.$route.query?.text || '';
    },
  },

  mounted() {
    sendGaEvent(new ContactClickedGaEvent().addPageSlug(this.$route.path));
  },

  methods: {
    handleFormSubmitted() {
      sendGaEvent(new ContactFormSubmittedGaEvent());

      if (this.$route.query?.text) {
        this.$router.replace({ query: {} });
      }
    },
    handleLinkClick(link) {
      const gaEvent = new ExternalLinkClickedGaEvent()
        .addLinkUrl(link.url)
        .addLinkType(link.platform)
        .addLinkName(link.label);

      sendGaEvent(gaEvent);
    },
  },
};
</script>

<style lang="scss" scoped>
.error-msg {
  margin-top: 10px;
  font-size: 16px;
}
</style>
